import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GamblingService } from '.';
import { bleachrHTTP } from '../_classes/http';
import { AccountModel, AccountThemeTabsModel } from '../_interfaces';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    public hide_match_chat: boolean = false;
    public tabs: BehaviorSubject<AccountThemeTabsModel[]> = new BehaviorSubject<AccountThemeTabsModel[]>([])
    public account: BehaviorSubject<AccountModel | null> = new BehaviorSubject<AccountModel | null>(null)

    constructor(
        private http: bleachrHTTP,
        private gamblingService: GamblingService
    ) { }

    async getAccountPromise(account_id: string = ``): Promise<AccountModel> {
        return await this.http.get<{ data: AccountModel }>(`${environment.BLEACHR_WEB_API}/accounts/${account_id}`)
            .then((res) => {
                if (!res?.data?.id) {
                    throw new Error('Error no account found')
                }

                const hide_gambling_offers_app_settings = this.gamblingService.hide_gambling_offers.getValue()

                if (
                    typeof res?.data?.theme_config?.hide_gambling_offers === 'boolean'
                    && res.data.theme_config.hide_gambling_offers !== hide_gambling_offers_app_settings.account_theme
                ) {
                    this.gamblingService.hide_gambling_offers.next({
                        ...hide_gambling_offers_app_settings,
                        account_theme: res.data.theme_config.hide_gambling_offers
                    })
                }

                if (res?.data?.theme_config?.tabs?.length) {
                    this.tabs.next(res.data.theme_config.tabs)
                }

                return res.data
            })
            .catch((err) => {
                throw err
            })
    }

    async getAccount(): Promise<AccountModel> {
        try {
            if (this.account.value && this.account.value.id) {
                return this.account.value
            }

            return await this.http.get<{ data: AccountModel }>(`${environment.BLEACHR_WEB_API}/accounts/id/tennis-one`)
                .then((res) => {
                    if (res?.data?.theme_config?.tabs?.length) {
                        this.tabs.next(res.data.theme_config.tabs)
                    }
                    if (res?.data?.id) {
                        this.account.next(res.data)
                    }

                    this.hide_match_chat = res.data.theme_config?.hide_individual_match_chat!

                    return res && res.data ? res.data : {} as AccountModel
                })
                .catch((err) => {
                    throw err
                })
        }
        catch (err) {
            throw err
        }
    }
}